import { HorizontalFlexbox } from "@src/components/layout/Flexbox";
import { cn } from "@src/lib/utils";
import type { ReactNode } from "react";

export interface SectionHeaderProps {
  children: ReactNode;
  className?: string;
  textClassName?: string;
  rightContent?: ReactNode;
}

/**
 * Small uppercase section header used to label groups of content within a page.
 * Tailwind-only replacement for the legacy SectionHeader.
 */
export const SectionHeader = ({
  children,
  className,
  textClassName,
  rightContent,
}: SectionHeaderProps) => {
  return (
    <HorizontalFlexbox
      alignItems="center"
      justifyContent="space-between"
      gap="sm"
      className={cn("py-1", className)}
    >
      <span
        className={cn(
          "text-xs font-semibold uppercase tracking-wider text-muted-foreground",
          textClassName,
        )}
      >
        {children}
      </span>
      {rightContent}
    </HorizontalFlexbox>
  );
};
